// extracted by mini-css-extract-plugin
module.exports = {"color_1":"#DB00FF","color_2":"#04BC00","color_3":"#0148FF"};